import { render, staticRenderFns } from "./textIcon.vue?vue&type=template&id=0d587301"
import script from "./textIcon.vue?vue&type=script&lang=js"
export * from "./textIcon.vue?vue&type=script&lang=js"
import style0 from "./textIcon.vue?vue&type=style&index=0&id=0d587301&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports